// BottomNavCliente — variante CLIENTE del BottomNav v5 (mismo look, rutas del panel).
// FIX D: barra inferior mobile (≤900px) con las 5 secciones más usadas del cliente (las menos usadas
// —Vecinos, Soporte— viven en el drawer del TopNavCliente). Sin badge de carrito público.
//
// Self-contained: <style>{CLBN_CSS}</style> + clases .clbn-* + tokens --tv5-* propios. Active state
// desde useLocation (drop-in). Solo visible en ≤900px.
import { Link, useLocation } from 'react-router-dom';

const ITEMS = [
  { key: 'inicio',  icon: '🏠', label: 'Inicio',  to: '/cliente' },
  { key: 'mi-plan', icon: '🎁', label: 'Mi Plan', to: '/cliente/mi-plan' },
  { key: 'pedidos', icon: '📦', label: 'Pedidos', to: '/cliente/pedidos' },
  { key: 'tienda',  icon: '🛒', label: 'Tienda',  to: '/catalogo' },
  { key: 'cuenta',  icon: '👤', label: 'Cuenta',  to: '/cliente/cuenta' },
];

const CLBN_CSS = `
.clbn {
  --tv5-teal:#00A8B5; --tv5-dim:rgba(248,246,241,0.45); --tv5-border:rgba(255,255,255,0.08);
  position:fixed; bottom:0; left:0; right:0; z-index:90; background:rgba(10,20,36,0.95);
  backdrop-filter:blur(20px); -webkit-backdrop-filter:blur(20px);
  border-top:1px solid var(--tv5-border); padding:8px 0 calc(8px + env(safe-area-inset-bottom,0px));
  display:grid; grid-template-columns:repeat(5,1fr); gap:4px;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
}
.clbn-item {
  background:transparent; border:0; color:var(--tv5-dim); padding:6px 8px;
  display:flex; flex-direction:column; align-items:center; gap:3px; min-height:44px; justify-content:center;
  font-size:11px; font-weight:600; text-decoration:none;
}
.clbn-item .clbn-icon { font-size:20px; line-height:1; }
.clbn-item.active { color:var(--tv5-teal); }
@media (min-width:900px){ .clbn { display:none; } }
`;

export function BottomNavCliente() {
  const location = useLocation();
  const path = location.pathname;
  const isActive = (to) => (to === '/cliente'
    ? path === '/cliente' || path === '/cliente/'
    : path.startsWith(to));
  return (
    <nav className="clbn">
      <style>{CLBN_CSS}</style>
      {ITEMS.map((it) => (
        <Link key={it.key} to={it.to} className={'clbn-item' + (isActive(it.to) ? ' active' : '')}>
          <span className="clbn-icon">{it.icon}</span><span>{it.label}</span>
        </Link>
      ))}
    </nav>
  );
}
